import {createStyles} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import useParentModalCid from 'ui-library/hooks/useParentModalCid';
import {DatetimePickerContext} from 'ui-library/inputs/DatetimePicker';
import {DateAndDatetimeBaseProps} from 'ui-library/inputs/InputConstants';

const useStyles = createStyles(() => ({
  // `display: contents` keeps this wrapper layout-neutral (it generates no box), so adding it around the
  // datetime input does not change how the cell renders. It exists only to expose a stable root element,
  // which lets callers detect that the datetime input is receiving the structured-table treatment.
  root: {
    display: 'contents',
  },
}));

/**
 * Wrapper component to properly render `DatetimePicker`s in structured tables.
 */
export default function StructuredTableDatetimeInputContainer<P extends DateAndDatetimeBaseProps>(props: {
  children: React.ReactElement<P>;
}): JSX.Element {
  const {classes} = useStyles();
  const {containerNodeSelector} = DatetimePickerContext.useContext();
  const [parentModalCid, datetimePickerRef] = useParentModalCid();

  const newProps: Partial<DateAndDatetimeBaseProps> = {
    datePickerPopperContainerSelector:
      parentModalCid != null ? `[data-modal-cid="${parentModalCid}"]` : containerNodeSelector,
    // Ensure table cell isn't auto-dismissed on click
    // See: client/notebook/mediocre/selection/block/MultiSelectListUtil.ts
    wrapperClassName: 'js-mediocre-active-edit',
    datetimePickerRef,
  };
  return (
    <div
      className={classes.root}
      {...getTestProps({component: 'StructuredTableDatetimeInputContainer', element: 'root'})}
    >
      {React.cloneElement(props.children, newProps)}
    </div>
  );
}
